import { HostMessageType } from './host-message-type';
import { Message } from './message';

export class HostMessage<TBody> extends Message<HostMessageType, TBody> {
  constructor(type: HostMessageType, body?: TBody) {
    super(type, body);
  }
}
